import { tgxApi } from "../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../helpers/utils/Utils"
import { downloadFile } from "../../helpers/utils/FileUtils";

export const customerApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getCustomerById: build.query({
            query: (customerId) => {
                return {
                    url: `/ajax/get-customer-by-id/${customerId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["customerById"]
        }),
        getCustomerByCustomerName: build.query({
            query: (customerName) => {
                return {
                    url: `/ajax/customer/${customerName}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["customerById"]
        }),
        getAllRegularCustomers: build.query({
            query: () => {
                return {
                    url: `/ajax/get-all-regular-customer`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAllCustomersList: build.query({
            query: () => {
                return {
                    url: `/ajax/get-all-customer-list`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["getAllCustomerList"]

        }),
        searchCustomers: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/customers?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['customers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        searchAutoHoaCustomers: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/auto-hoa?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['customers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createCustomer: build.mutation({
            query: (requestBody) => ({
                url: `/ajax/submitAccount`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody
            }),
            invalidatesTags: ['customers'],
            async onQueryStarted(_, { queryFulfilled }) {
               
                    await handleQueryErrorAndSuccess(queryFulfilled,"created", "Customer");
                }
          
        }),



        updateCustomer: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/customer`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['customers', 'customerById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Customer")
            },
        }),


        getParentCustomerByTenant: build.query({
            query: (tenantId) => {
                return {
                    url: `/ajax/get-all-parent-customer-by-tenant/${tenantId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        getParentAllCustomer: build.query({
            query: (tenantId) => {
                return {
                    url: `/ajax/get-all-parent-customer`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),
        getAllSubordinateCustomers: build.query({
            query: (id) => {
                return {
                    url: `/customers/subordinate`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    params: { id }
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),
        getCustomerByTenantAndLevel: build.query({
            query: ({ tenantName, level }) => {
                return {
                    url: `/ajax/get-all-customer-by-tenant-and-level/${tenantName}/${level}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),
        getAllCustomerByTenant: build.query({
            query: ({ tenantName }) => {
                return {
                    url: `/ajax/get-all-customer-tenant/${tenantName}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        getAllFulfillmentCustomerByTenant: build.query({
            query: (tenantName) => {
                return {
                    url: `/ajax/get-all-fulfillment-customer-tenant/${tenantName}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ["getAllFulfillmentCustomerByTenant"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            }
        }),

        exportCustomerData: build.query({
            query: (query) => {
                return {
                    url: `/export/customer`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("customers"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        deleteCustomerById: build.mutation({
            query: ({ customerId }) => ({
                url: `/ajax/customers/soft_delete/${customerId}`,
                method: 'DELETE',
                headers: getAuthorizationHeader(),
            }),
            invalidatesTags: ['customers'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Customers");
            },
        }),

    }),
});


export const {
    useGetAllRegularCustomersQuery,
    useGetAllCustomersListQuery,
    useGetCustomerByIdQuery,
    useLazyGetCustomerByIdQuery,
    useSearchCustomersQuery,
    useLazySearchCustomersQuery,
    useCreateCustomerMutation,
    useUpdateCustomerMutation,
    useGetParentCustomerByTenantQuery,
    useLazyExportCustomerDataQuery,
    useLazyGetCustomerByTenantAndLevelQuery,
    useLazyGetAllCustomerByTenantQuery,
    useGetParentAllCustomerQuery,
    useGetAllCustomerByTenantQuery,
    useGetAllFulfillmentCustomerByTenantQuery,
    useSearchAutoHoaCustomersQuery,
    useDeleteCustomerByIdMutation,

} = customerApi;